export default __webpack_public_path__ + "static/media/shirtArcelikBayi.33943d69.jpg";